/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import PodiumListItem from './PodiumListItem';
export default class LeaderboardPodium extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const state = app.leaderboard;
    if (state.isEmpty() || state.isInitialLoading()) {
      return null;
    }
    return m("ul", {
      className: "LeaderboardPodium"
    }, state.getPodium().map((user, i) => m("li", {
      className: "LeaderboardPodium-item",
      key: user.id(),
      "data-id": user.id()
    }, this.listItem(user, this.getPosition(i)))));
  }
  getPosition(index) {
    if (index === 0 && app.leaderboard.getPodium().length === 1) {
      return 1;
    }
    switch (index) {
      case 0:
        return 2;
      case 1:
        return 1;
      case 2:
        return 3;
    }
  }
  listItem(user, position) {
    return m(PodiumListItem, {
      user: user,
      value: app.leaderboard.scoreOf(user),
      position: position
    });
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/leaderboards/components/LeaderboardPodium', LeaderboardPodium);